module.exports = __webpack_public_path__ + "img/75672.9a2f535a.svg";